import { render } from "./DismissingAlerts.vue?vue&type=template&id=126c5830"
import script from "./DismissingAlerts.vue?vue&type=script&lang=js"
export * from "./DismissingAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__